import { createEnum, requestState } from '../utils/actionTypesHelpers';

export default createEnum(
  {
    update: createEnum(requestState, 'workingHourNotes.update'),
  },
  'workingHourNotes',
);
